import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store/store";
import useLoading from "../useLoading";
import useApiErrorHandler from "../useApiErrorHandler";
import DteTestRequirementService from "../../services/dte/DteTestRequirementService";

import {
    setLoading,
    loadList,
    setError,
} from "../../store/slices/dte/dteTestRequirementSlice";

export const useDteTestRequirements = () => {
    const dispatch: AppDispatch = useDispatch();
    const { showLoadingIndicator, hideLoadingIndicator } = useLoading();
    const { handle } = useApiErrorHandler();

    // GLOBAL STATE
    const { list, loading, error } = useSelector(
        (state: RootState) => state.dteTestRequirements
    );

    // =========================================================
    // FETCH LIST
    // =========================================================
    const fetchTestRequirements = async () => {
        try {
            dispatch(setLoading(true));
            showLoadingIndicator();

            const response = await DteTestRequirementService.listActive();
            console.log(response);
            const { statusCode, data } = response;

            if (statusCode === 200) {
                dispatch(loadList(data || []));
            }
        } catch (err) {
            handle(err);
            dispatch(setError("No se pudo cargar los requisitos de pruebas DTE"));
        } finally {
            hideLoadingIndicator();
            dispatch(setLoading(false));
        }
    };

    return {
        list,
        loading,
        error,
        fetchTestRequirements,
    };
};

export default useDteTestRequirements;
